import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';
import { User } from '../models/user';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  api_error: any;
  loginId = '';
  password = '';
  secondPassword;
  userType = '';
  returnUrl: any;
  logintype: any;
  api_success: string;
  loginForm: any;
  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private user: User
  ) {
    this.userService.getUserTypes()
      .subscribe(data => {
        this.logintype = data;
        // console.log(this.logintype);
      });
  }

  ngOnInit() {
    this.userType = 'superadmin';
    // this.userType = localStorage.getItem('userType');
    // console.log(this.userType);
    // reset login status
    this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    //this.returnUrl = this.route.snapshot.['returnUrl'] || '/';

  }

  login(loginForm: NgForm) {
    this.user.loginId = loginForm.value.loginId;
    this.user.password = loginForm.value.password;
    this.user.secondPassword = loginForm.value.secondPassword;
    this.user.userType = loginForm.value.userType;
    // console.log(this.user.userType);
    switch (this.user.userType) {
      case 'superadmin':
        this.authenticationService.login(this.user)
        .subscribe(
          data => {
            this.router.navigate(['/home/dashboard']);
          },
          (error) => {
            this.api_error = error.error;
          }
        );
        break;
      case 'support':
        this.authenticationService.support_login(this.user)
        .subscribe(
          data => {
            this.router.navigate(['/home/dashboard']);
          },
          (error) => {
            this.api_error = error.error;
          }
        );
        break;
      default:
        this.authenticationService.marketing_login(this.user)
        .subscribe(
          data => {
            this.router.navigate(['/home/dashboard']);
          },
          (error) => {
            this.api_error = error.error;
          }
        );
        
    }
  }
}
